import React , { useState, useEffect } from 'react';
import API_BASE_URL from "../Config";
import { useOutletContext, useNavigate } from "react-router-dom";



function FjSpecial() {
  const { posts, setPosts, loading, setLoading } = useOutletContext();
  const [locationError, setLocationError] = useState("");
  const [locationStatus, setLocationStatus] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);
  const [postDetails, setPostDetails] = useState(null);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [hasNext, setHasNext] = useState(true);
  
  const [page, setPage] = useState(1);

  const [fjSpecialData, setFjSpecialData] = useState([]);
  const [showFjSpecial, setShowFjSpecial] = useState(false);
  // const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  
  useEffect(() => {
      fetchFJSpecialPosts(1);
  }, []);



  const fetchFJSpecialPosts = (pageNumber) => {
    setLoading(true);

    if (!("geolocation" in navigator)) {
      setLocationError("❌ Geolocation is not supported by your browser.");
      setLoading(false);
      return;
    }

    setLocationStatus("Requesting your location...");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        setLocationStatus("Location detected ✅");

        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        console.log("latitude fetchFJSpecialPosts", latitude);
        console.log("longitude fetchFJSpecialPosts", longitude);

        try {
          const res = await fetch(
            `${API_BASE_URL}/api/fj-special?latitude=${latitude}&longitude=${longitude}&near_by=True&page=${pageNumber}`
          );

          const data = await res.json();

          if (data.status === 1) {
            setFjSpecialData((prev) =>
              pageNumber === 1
                ? data.response.fj_special
                : [...prev, ...data.response.fj_special]
            );

            setHasNext(data.response.has_next);
          }
        } catch (err) {
          console.log("API Error:", err);
        }

        setLoading(false);
      },

      (error) => {
        setLocationError("⚠️ Please allow location access to see nearby posts.");
        setLoading(false);
      }
    );
  };


  const handleContactClick = async (post) => {
    console.log("asdfsd ==================post==== ")
    console.log(post)
    console.log("asdfsd ==================post==== ")
    console.log(post)
    try {
      const res = await fetch(`${API_BASE_URL}/api/fj-special/${post.id}`);

      const data = await res.json();
      console.log("asdfsd ====================== ")
      console.log(data)
      console.log(data.response)
      setPostDetails(data.response);
      setShowModal(true);

    } catch (err) {
      console.log(err);
    }
  };



  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>{locationStatus}</p>
      </div>
    );
  }

  if (locationError) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px", color: "red" }}>
        {locationError}
      </div>
    );
  }

  return (
    <div>
       <div className="home_three_container">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12 col-md-12">
                <div className="blog_wrapper blog_wrapper_details">
                    <div className="comments_box">
                    <div className="section_title mb-1 mt-5">
                            <p>F-J</p>
                            <h2>Special</h2>
                        </div>

                    <div className="row">
                        {fjSpecialData.length > 0 ? (
                        fjSpecialData.map((post) => (
                            <div key={post.id} className="col-lg-4 pb-3">
                            {post.custom_user}
                            <div className="comment_list">
                                <div className="comment_thumb">
                                {post.gender === "male" ? (
                                    <img
                                    src="assets/images/boy.jpg"
                                    alt="male"
                                    style={{ width: 50, height: 50 }}
                                    />
                                ) : post.gender === "female" ? (
                                    <img
                                    src="assets/images/girl.png"
                                    alt="female"
                                    style={{ width: 50, height: 50 }}
                                    />
                                ) : (
                                    <img
                                    src="assets/images/company.jpg"
                                    alt="company"
                                    style={{ width: 50, height: 50 }}
                                    />
                                )}
                                </div>
                                <div className="comment_content">
                                <div className="comment_meta">
                                    <h5>
                                    <a href="#">{post.brand_name}</a>
                                    </h5>
                                    <h5>
                                    <a href="#">{post.branch_name}</a>
                                    </h5>
                                    <span>
                                    {post.time_ago} -{" "}
                                    <span>({post.distance} km away)</span>
                                    </span>
                                </div>
                                <p className="title">
                                    <strong>{post.title}</strong>
                                </p>
                                <p className="description">Valid till: {post.expiry_date}</p>
                                <p className="description">{post.description}</p>

                                <div className="comment_reply">
                                    <button onClick={() => handleContactClick(post)}>
                                    <i className="fa fa-eye"></i>
                                    </button>
                                </div>
                                </div>
                            </div>
                            </div>
                        ))
                        ) : (
                        <p>No nearby posts found.</p>
                        )}
                    </div>

                    {hasNext && (
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <button
                            className="btn btn-primary purple__button"
                            onClick={() => {
                            const nextPage = page + 1;
                            setPage(nextPage);
                            fetchFJSpecialPosts(nextPage);
                            }}
                        >
                            Load More
                        </button>
                        </div>
                    )}

                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>

      {/* Modal */}
      <div className={`modal fade ${showModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: showModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">FJ Special Post Details</h5>
              <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
            </div>
            <div className="modal-body">
              {loading && <div className="text-center">Loading...</div>}
              {error && <div className="alert alert-danger">{error}</div>}
              {postDetails && (
                <>
                  <h5 className="text-primary">{postDetails.brand_name}</h5>
                  <h5 className="text-primary">{postDetails.branch_name}</h5>
                  <h5 className="text-primary">{postDetails.title}</h5>
                  <p className="mb-3" style={{ whiteSpace: "pre-wrap" }}>{postDetails.description}</p>
                  <p className="mb-3"> valid till: {postDetails.expiry_date}</p>

                  {postDetails.hide_whatsapp ? (
                    <p><strong>WhatsApp:</strong> WhatsApp is hidden</p>
                  ) : (
                    <p><strong>WhatsApp:</strong> {postDetails.whatsapp_number} <a href={`https://wa.me/${postDetails.whatsapp_number}`} target="_blank" rel="noopener noreferrer"><i className="ion-social-whatsapp-outline"></i></a></p> 
                  )}
                  
                    {postDetails.document && (
                        <div className=""> Document:  
                            <a href={postDetails.document} target="_blank">
                                <button className='btn-primary'><i className="fa fa-eye"></i></button>
                            </a>
                        </div>
                    )}
                   
                </>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
  </div>
  );
}

export default FjSpecial;
